import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-window" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-btns" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex-row"
}
const _hoisted_8 = {
  key: 2,
  class: "flex-row"
}
const _hoisted_9 = {
  key: 3,
  class: "flex-row"
}
const _hoisted_10 = {
  key: 4,
  class: "flex-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.modalTitle), 1),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.buttonOptions == _ctx.ModalButtonOptions.OKAY)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "border-t",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
              }, "Okay")
            ]))
          : (_ctx.buttonOptions == _ctx.ModalButtonOptions.YES_NO)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "border-t",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
                }, "NO"),
                _createElementVNode("button", {
                  class: "border-t border-l",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm')))
                }, "YES")
              ]))
            : (_ctx.buttonOptions == _ctx.ModalButtonOptions.ADD_CANCEL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "border-t",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
                  }, "CANCEL"),
                  _createElementVNode("button", {
                    class: "border-t border-l themed",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('confirm')))
                  }, "ADD")
                ]))
              : (_ctx.buttonOptions == _ctx.ModalButtonOptions.DELETE_CANCEL)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "border-t",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cancel')))
                    }, "CANCEL"),
                    _createElementVNode("button", {
                      class: "border-t border-l danger",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('confirm')))
                    }, "DELETE")
                  ]))
                : (_ctx.buttonOptions == _ctx.ModalButtonOptions.SAVE_CANCEL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "border-t",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('cancel')))
                      }, "CANCEL"),
                      _createElementVNode("button", {
                        class: "border-t border-l themed",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('confirm')))
                      }, "SAVE")
                    ]))
                  : _createCommentVNode("", true)
      ])
    ])
  ]))
}